export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/placeholder-f771455e07d39b0841a3f0d4a2143c5d.jpg";